import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import Spinner from '../../components/Layout/Spinner';
import { formatDate } from '../../utils/formatDate';

const PaymentHistory = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPaymentHistory = async () => {
      try {
        const res = await axios.get('/api/v1/payments/me');
        setPayments(res.data.data);
        setLoading(false);
      } catch (err) {
        toast.error(err.response?.data?.error || 'Error fetching payment history');
        setLoading(false);
      }
    };

    fetchPaymentHistory();
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Payment History</h2>
      
      {payments.length === 0 ? (
        <div className="alert alert-info">
          <h5>No payment records found</h5>
          <p>You haven't made any payments yet.</p>
        </div>
      ) : (
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Transaction ID</th>
                    <th>Subscription Plan</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Invoice</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((payment) => (
                    <tr key={payment._id}>
                      <td>{formatDate(payment.createdAt)}</td>
                      <td>{payment.transactionId}</td>
                      <td>{payment.subscription.plan.name}</td>
                      <td>${payment.amount}</td>
                      <td>
                        <span className={`badge ${payment.status === 'successful' ? 'bg-success' : 'bg-danger'}`}>
                          {payment.status}
                        </span>
                      </td>
                      <td>
                        <button className="btn btn-sm btn-outline-secondary">
                          <i className="fas fa-file-download me-1"></i> Receipt
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentHistory;
